import { PropsWithChildren } from 'react';

import { useTranslation } from 'next-i18next/pages';

import { TranslationNamespace } from '@/i18n';

import styles from './LoginRegistrationContainer.module.scss';

export const LoginRegistrationContainer = ({ children }: PropsWithChildren) => {
	const { t } = useTranslation(TranslationNamespace.LoginRegistration);
	return (
		<main>
			<div className={styles.container}>
				<div className={styles.containerInner}>
					<div className={styles.visual}>
						<div className={styles.visualContent}>
							<img alt="" src="/img/login-tiles.svg" className={styles.tiles} />
							<div className={styles.description}>
								<img alt="Логотип Fishplace" src="/img/logo.svg" className={styles.logo} />

								<span className={styles.description}>{t('auth.automate-processes')}</span>
							</div>
						</div>
					</div>

					<div className={styles.form}>
						<div className={styles.formContent}>{children}</div>
					</div>
				</div>
			</div>
		</main>
	);
};
